export const firebaseConfig = {
  apiKey: 'AIzaSyCwHYiZKHaf77NTpGbulYodFEd3O68pJDU',
  authDomain: 'weguide-app.firebaseapp.com',
  databaseURL: 'https://weguide-app.firebaseio.com',
  projectId: 'weguide-app',
  storageBucket: 'weguide-app.appspot.com',
  messagingSenderId: '898635942900',
  appId: '1:898635942900:web:fed6cc6a84c174e40787a1',
  measurementId: 'G-CZ110JLW4Q',
  mixpanelProjectToken: 'd44565724638b5cda6974a5140d58729',
};
